module.exports = __webpack_public_path__ + "static/media/dRoe.2b8356e6.jpeg";